import styled from 'styled-components';

export const ScreenSeparator = styled.div<{ margin?: string }>`
  border-top: 1px solid var(--color-gray-grayBold);
  margin: ${({ margin }) => (margin ? margin : '2rem 0 2rem 0')};
  width: 100%;
`;
